import { useExperimentFlagExposed } from '@zenbusiness/application-commons-experiments';

import { ENABLE_APPLE_PAY } from '#client/constants/experimentFlags';

import PaymentCheckoutCard from './PaymentCheckoutCard';
import PaymentCheckoutCardApplePay from './PaymentCheckoutCardApplePay';

function Index(props) {
  const { value: enableApplePay } = useExperimentFlagExposed(ENABLE_APPLE_PAY, false);

  return enableApplePay ? (
    <PaymentCheckoutCardApplePay {...props} />
  ) : (
    <PaymentCheckoutCard {...props} />
  );
}

export default Index;
